export default {
  methods: {
    calculateBradescoSeguros(infos, table) {
      const { age, selectedValue } = infos;
      const tableColRef = "valor" + selectedValue;
      const tableRow = table.filter(row => row.idade === parseInt(age));

      if (!tableRow.length) {
        return "Faixa etária não comercializada";
      } else if (
        !tableRow[0][tableColRef] ||
        tableRow[0][tableColRef] == undefined
      ) {
        return "Valor não comercializado para esta faixa etária";
      } else {
        return parseFloat(tableRow[0][tableColRef]);
      }
    },
    calculateIcatuSeguros(infos, table) {
      const { age, selectedValue } = infos;
      const tableRow = table.filter(row => row.idade == age);

      if (!tableRow.length) {
        return "Faixa etária não comercializada";
      } else {
        const { morteate1mi, ipa, saffamiliar } = tableRow[0];
        return parseFloat(
          (
            (selectedValue * morteate1mi +
              selectedValue * ipa +
              5500 * saffamiliar) /
            1000
          ).toFixed(2)
        );
      }
    },
    calculateMongeralAegon(infos, table) {
      const { age, gender, selectedValue } = infos;
      const tableRow = table.filter(row => row.idade == age);

      if (!tableRow.length) {
        return "Faixa etária não comercializada";
      } else {
        const { mortehomens, mortemulheres, ipa, saffamiliar } = tableRow[0];
        const morte = gender === "M" ? mortehomens : mortemulheres;
        return parseFloat(
          (
            ((selectedValue * morte + selectedValue * ipa) / 1000)  + saffamiliar
          ).toFixed(2)
        );
      }
    },
    calculatePortoSeguro(infos, table) {
      const { age, selectedValue } = infos;
      const rowReference = age <= 25 ? 25 : age;
      const tableColRef = "valor" + selectedValue;
      const tableRow = table.filter(
        row => row.idade === parseInt(rowReference)
      );
      const safFamiliar = 5.8;
      const factor = 0.87046;
      const rowValue = tableRow.length && tableRow[0][tableColRef];
      if (!tableRow.length) {
        return "Faixa etária não comercializada";
      } else {
        return parseFloat((rowValue + safFamiliar) * factor);
      }
    }
  }
};
